<div class="row justify-content-center">
  <div class="col-lg-6">
    <div class="block border my-2">
      <div class="border-bottom p-2">
        <ul class="nav nav-pills nav-fill" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                    [ngClass]="{'active': tab === 'profile'}"
                    (click)="tab = 'profile'"
                    data-bs-target="#profile" type="button" role="tab" aria-controls="profile"
                    aria-selected="false" translate>app.user.profile-tab
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="security-tab" data-bs-toggle="tab"
                    [ngClass]="{'active': tab === 'security'}"
                    (click)="tab = 'security'"
                    data-bs-target="#security" type="button" role="tab" aria-controls="security"
                    aria-selected="false" translate>app.user.security-tab
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link disabled" id="settings-tab" data-bs-toggle="tab"
                    [ngClass]="{'active': tab === 'settings'}"
                    (click)="tab = 'settings'"
                    data-bs-target="#settings" type="button" role="tab" aria-controls="settings"
                    aria-selected="false" translate>app.user.settings-tab
            </button>
          </li>
        </ul>
        <div class="tab-content mt-4">
          <div class="tab-pane" id="profile"
               [ngClass]="{'active': tab === 'profile'}"
               role="tabpanel" aria-labelledby="profile-tab">
            <div class="mb-3">
              <label class="form-label" for="userName" translate>app.user.name</label>
              <input type="text" id="userName" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="user.name"/>
            </div>
            <div class="mb-3">
              <label class="form-label" for="login" translate>app.user.login</label>
              <input type="text" id="login" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="user.login"/>
            </div>
            <div class="mb-3">
              <label class="form-label" for="userFirst" translate>app.user.first</label>
              <input type="text" id="userFirst" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="user.first"/>
            </div>
            <div class="mb-3">
              <label class="form-label" for="userLast" translate>app.user.last</label>
              <input type="text" id="userLast" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="user.last"/>
            </div>
            <div class="mb-3">
              <label class="form-label" for="userMiddle" translate>app.user.middle</label>
              <input type="text" id="userMiddle" autocomplete="off"
                     class="form-control form-control-sm"
                     [(ngModel)]="user.middle"/>
            </div>
            <button class="btn btn-sm btn-primary" (click)="edit()" translate>app.user.button.save</button>
          </div>
          <div class="tab-pane" id="security"
               [ngClass]="{'active': tab === 'security'}"
               role="tabpanel" aria-labelledby="security-tab">
            <div class="mb-3" *ngIf="user.currentPasswordVisible">
              <label class="form-label" for="currentPassword" translate>app.user.current-password</label>
              <div class="input-group input-group-sm">
                <input type="password" id="currentPassword" autocomplete="off"
                       class="form-control form-control-sm" [disabled]="loading"
                       [(ngModel)]="user.currentPassword"/>
                <span class="input-group-text icon icon24 eye px-2"></span>
              </div>
              <div class="text-danger" *ngIf="submitted && isEmpty(user.currentPassword)" translate>
                app.user.current-password.empty
              </div>
              <div class="text-danger" *ngIf="submitted && user.currentPassword.length < 6" translate>
                app.user.current-password.length
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="newPassword" translate>app.user.new-password</label>
              <div class="input-group input-group-sm">
                <input type="password" id="newPassword" autocomplete="off"
                       class="form-control form-control-sm" [disabled]="loading"
                       [(ngModel)]="user.newPassword" (ngModelChange)="typingPassword()"/>
                <span class="input-group-text icon icon24 eye px-2"></span>
              </div>
              <div *ngIf="user.passwordRequirements.typing || !isEmpty(user.newPassword)" class="mt-3">
                <div *ngIf="!metRequirements() && !user.passwordRequirements.reset">
                  Password requirements met:
                </div>
                <div *ngIf="!metRequirements() && user.passwordRequirements.reset">
                  Create a password that contains at least:
                </div>
                <div *ngIf="metRequirements()">Password requirements met!</div>
                <ul>
                  <li
                    [ngClass]="{'text-danger' : !isEmpty(user.newPassword) && !user.passwordRequirements.length,
                    'text-success' : !isEmpty(user.newPassword) && user.passwordRequirements.length}">
                    6 characters
                  </li>
                  <li
                    [ngClass]="{'text-danger' : !isEmpty(user.newPassword) && !user.passwordRequirements.number,
                    'text-success' : !isEmpty(user.newPassword) && user.passwordRequirements.number}">
                    1 number
                  </li>
                  <li
                    [ngClass]="{'text-danger' : !isEmpty(user.newPassword) && !user.passwordRequirements.unique,
                    'text-success' : !isEmpty(user.newPassword) && user.passwordRequirements.unique}">
                    4 unique characters
                  </li>
                  <li
                    [ngClass]="{'text-danger' : !isEmpty(user.newPassword) && !user.passwordRequirements.special,
                    'text-success' : !isEmpty(user.newPassword) && user.passwordRequirements.special}">
                    1 special character <span class="text-muted">e.q., $, !, &commat;, &percnt;, &amp;</span></li>
                  <li
                    [ngClass]="{'text-danger' : !isEmpty(user.newPassword) && !user.passwordRequirements.whitespace,
                    'text-success' : !isEmpty(user.newPassword) && user.passwordRequirements.whitespace}">
                    No leading or trailing whitespace
                  </li>
                </ul>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="repeatPassword" translate>app.user.repeat-password</label>
              <div class="input-group input-group-sm">
                <input type="password" id="repeatPassword" autocomplete="off"
                       class="form-control form-control-sm" [disabled]="loading"
                       [(ngModel)]="user.repeatPassword"/>
                <span class="input-group-text icon icon24 eye px-2"></span>
              </div>
              <div *ngIf="submitted && isEmpty(user.repeatPassword)" translate>app.user.repeat-password.empty</div>
              <div *ngIf="submitted && user.newPassword !== user.repeatPassword" translate>
                app.user.repeat-password.not-equals
              </div>
              <div class="text-danger" *ngIf="!isEmpty(user.error)">{{ user.error }}</div>
            </div>

            <button class="btn btn-sm btn-primary" (click)="changePassword()" translate>
              app.user.button.change-password
            </button>
          </div>
          <div class="tab-pane" id="settings"
               [ngClass]="{'active': tab === 'settings'}"
               role="tabpanel" aria-labelledby="settings-tab">
            settings for personal tune
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
